import { Box, Dialog, DialogContent, Grid, LinearProgress, Typography } from '@material-ui/core';
import React from 'react';

const LoadingModal = ({ open, progress = 0, handleClose = () => {}, mensagem }) => {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <Grid item xs={12} style={{ padding: 10 }}>
        <Typography color="textPrimary" align="center" style={{ fontSize: 18 }}>
          {mensagem ? mensagem : 'Esta ação pode demorar alguns minutos...'}
        </Typography>
      </Grid>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress variant="determinate" value={progress} />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="text.secondary">{`${Math.round(progress)}%`}</Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingModal;
